module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_5012.a409777d.png";